// extracted by mini-css-extract-plugin
export var content = "_q0-1";
export var fullScreen = "_q0-0";